import { AcsEvent } from '../../../services/SplService';

/**
 * Generate Acs Event Detail info to add to PDF.
 */
export default function generateAcsEventDetailsInfo(acsEvent: AcsEvent) {
  const acsEventDetailsInfoLabels = [
    ...(acsEvent?.dateReceived ? [`ACS Event Received:`] : []),
    ...(acsEvent?.reason ? [`Reason:`] : []),
    ...(acsEvent?.uspsDeliverabilityCode ? [`Deliverability Code:`] : []),
    ...(acsEvent?.uspsCOAName ? [`COA Name:`] : []),
    ...(acsEvent?.eventDetails?.address ? [`New Address:`] : []),
    ...(acsEvent?.eventDetails?.moveType ? [`Move Type: `] : []),
    ...(acsEvent?.eventDetails?.uspsNewAddressType ? [`New Address Type: `] : []),
    ...(acsEvent?.eventDetails?.moveEffectiveDate ? [`Move Effective Date: `] : []),
    ...(acsEvent?.eventDetails?.madeAvailableDate ? [`Move Available Date: `] : []),
    ...(acsEvent?.eventDetails?.uspsSiteID ? [`USPS Site ID: `] : []),
    ...(acsEvent?.eventDetails?.uspsOldAddress ? [`USPS Old Address: `] : [])
  ];

  const acsEventDetailsInfoValues = [
    ...(acsEvent?.dateReceived ? [`${acsEvent.dateReceived}`] : []),
    ...(acsEvent?.reason ? [`${acsEvent.reason}`] : []),
    ...(acsEvent?.uspsDeliverabilityCode ? [`${acsEvent.uspsDeliverabilityCode}`] : []),
    ...(acsEvent?.uspsCOAName ? [`${acsEvent.uspsCOAName}`] : []),
    ...(acsEvent?.eventDetails?.address ? [`${acsEvent.eventDetails.address}`] : []),
    ...(acsEvent?.eventDetails?.moveType ? [`${acsEvent.eventDetails.moveType}`] : []),
    ...(acsEvent?.eventDetails?.uspsNewAddressType ? [`${acsEvent.eventDetails.uspsNewAddressType}`] : []),
    ...(acsEvent?.eventDetails?.moveEffectiveDate ? [`${acsEvent.eventDetails.moveEffectiveDate}`] : []),
    ...(acsEvent?.eventDetails?.madeAvailableDate ? [`${acsEvent.eventDetails.madeAvailableDate}`] : []),
    ...(acsEvent?.eventDetails?.uspsSiteID ? [`${acsEvent.eventDetails.uspsSiteID}`] : []),
    ...(acsEvent?.eventDetails?.uspsOldAddress ? [`${acsEvent.eventDetails.uspsOldAddress}`] : [])
  ];

  return { acsEventDetailsInfoLabels, acsEventDetailsInfoValues };
}
